import $api from "@/core/services/ApiService";
import { AxiosRequestConfig, AxiosResponse } from "axios";

class TransactionEndpoint {
  public list(params: AxiosRequestConfig = {}): Promise<AxiosResponse> {
    return $api.get("a/transactions", params);
  }

  public approveApiPayment(
    params: AxiosRequestConfig = {}
  ): Promise<AxiosResponse> {
    return $api.post("a/transactions/approve-api-payments", params);
  }

  public statistic(params: AxiosRequestConfig = {}): Promise<AxiosResponse> {
    return $api.get("a/transactions/statistic", params);
  }

  public columns(params: AxiosRequestConfig = {}): Promise<AxiosResponse> {
    return $api.get("a/transactions/columns", params);
  }

  public credit(params: AxiosRequestConfig = {}): Promise<AxiosResponse> {
    return $api.post("a/transactions/credit", params);
  }

  public history(
    id: string | number,
    params: AxiosRequestConfig = {}
  ): Promise<AxiosResponse> {
    return $api.get(`a/transactions/${id}/history`, params);
  }

  public view(
    id: string | number,
    params: AxiosRequestConfig = {}
  ): Promise<AxiosResponse> {
    return $api.get(`a/transactions/${id}`, params);
  }
}

export default TransactionEndpoint;
